;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.Steps = Marionette.ItemView.extend({
		tagName: 'div',
		template: JST.Steps,
		model: new Backbone.Model(),
		initialize(){
			this.model.set({
				season: CONFIG.SEASON
			})
		}
	})

}(window, APP, Backbone, Marionette, $, _));
